/**
 * 产品与技术 → 建筑管路系统综合解决方案
 *
 * 这里是该栏目全部二级菜单（= 二级产品页）的唯一数据源：
 * 导航菜单、路由、页面内容、3D 构建图全部从这里取，新增一个系统只需加一条。
 *
 * 切图由 tools/build_building_pipe_images.py 依《建筑管路系统产品页-切图规格书》
 * 从「网站图」原始素材生成，输出到 src/img/product-5/<slug>/。
 */

// 同一目录下按约定命名取图（webpack 会为 img/product-5 建立一个 require 上下文）
const img = (slug, name) => require('@/img/product-5/' + slug + '/' + name)

const shot = slug => ({
  banner: img(slug, 'banner.jpg'),
  banner2x: img(slug, 'banner@2x.jpg'),
  pic: img(slug, 'p1-pic.jpg'),
  pic2x: img(slug, 'p1-pic@2x.jpg'),
  info: img(slug, 'p1-info.jpg'),
  info2x: img(slug, 'p1-info@2x.jpg'),
  desc: img(slug, 'p1-desc.jpg'),
  desc2x: img(slug, 'p1-desc@2x.jpg'),
  mobile: img(slug, 'p1-m.jpg'),
  mobile2x: img(slug, 'p1-m@2x.jpg')
})

const SYSTEMS = [
  {
    slug: 'stainless-supply',
    name: '工程不锈钢给水管路系统',
    short: '工程不锈钢给水',
    en: 'STAINLESS STEEL WATER SUPPLY',
    model: 'press-fitting',
    model3dTitle: '双卡压不锈钢管件',
    pdf: ''
  },
  {
    slug: 'ep-fire',
    name: '快装EP消防管路系统',
    short: '快装EP消防',
    en: 'EP FIRE PROTECTION PIPING',
    model: 'grooved-coupling',
    model3dTitle: '沟槽卡箍快装接头',
    pdf: ''
  },
  {
    slug: 'ep-gas',
    name: '快装EP燃气管路系统',
    short: '快装EP燃气',
    en: 'EP GAS PIPING SYSTEM',
    model: 'gas-quick-joint',
    model3dTitle: '燃气快装机械接头',
    pdf: ''
  },
  {
    slug: 'hvac-composite',
    name: '暖通耐腐复合管路系统',
    short: '暖通耐腐复合',
    en: 'HVAC COMPOSITE PIPING',
    model: 'multilayer-composite',
    model3dTitle: '五层复合管壁结构',
    pdf: ''
  },
  {
    slug: 'drainage',
    name: '工程排水管路系统',
    short: '工程排水',
    en: 'ENGINEERING DRAINAGE SYSTEM',
    model: 'drainage-tee',
    model3dTitle: '45° 汇流承插三通',
    pdf: ''
  },
  {
    slug: 'plastic-municipal',
    name: '塑料管道-建筑与市政管路系统',
    short: '建筑与市政',
    en: 'BUILDING & MUNICIPAL PLASTIC PIPING',
    model: 'electrofusion-coupler',
    model3dTitle: 'PE 电熔套筒接口',
    pdf: ''
  },
  {
    slug: 'plastic-home',
    name: '塑料管道-家庭管路系统',
    short: '家庭管路',
    en: 'RESIDENTIAL PLASTIC PIPING',
    model: 'manifold',
    model3dTitle: '家用分水器总成',
    pdf: ''
  }
].map(s => Object.assign(s, shot(s.slug), { path: '/product-building/' + s.slug }))

export const BUILDING_SYSTEMS = SYSTEMS

export function findSystem (slug) {
  return SYSTEMS.filter(s => s.slug === slug)[0] || null
}

export default SYSTEMS
